import { sendAxiosRequest } from "@api/request.js";

function soloPirotecnia() {
  const dominioURL = window.location.href;
  var soloPirotecnia = dominioURL.includes("?pirotecnia");

  console.log("esPirotecnia", soloPirotecnia);
  return soloPirotecnia;
}

// promotions
async function getPromotions() {
  var data = {
    soloPirotecnia: soloPirotecnia(),
  };

  const url = `${import.meta.env.VITE_API_BASE_URL}/api/promociones`;

  const config = {
    method: "post",
    url: url,
    data: data,
    headers: {
      Accept: "*/*",
    },
  };

  return await sendAxiosRequest(config);
}

export {
  // promotions
  getPromotions,
};
